class QuizQuestions {
  constructor(node) {
    this.node = node;
    this.init();

    this.node.addEventListener('click', (e) => {
      if (e.target.nodeName !== 'LABEL') return;

      this.node.querySelectorAll('label').forEach((label) => {
        label.classList.remove('isActive');
      });
      e.target.classList.add('isActive');
    });
  }

  init() {
    this.node.querySelectorAll('input').forEach((input) => {
      if (input.checked) {
        input.nextElementSibling.classList.add('isActive');
      }
    });
  }
}

[...document.querySelectorAll('.Quiz .gfield_radio')].forEach((node) => {
  new QuizQuestions(node);
});

class QuizFooter {
  constructor() {
    this.node = document.querySelector('.Quiz .gform_page_footer');

    if (this.node && this.node.children && this.node.children.length < 2) {
      this.node.classList.add('flexEnd');
    }
  }
}

new QuizFooter();

const observer = new MutationObserver(() => {
  new QuizFooter();
  [...document.querySelectorAll('.Quiz .gfield_radio')].forEach((node) => {
    new QuizQuestions(node);
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});